// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module__footer___Xyj4N","footerLinks":"footer-module__footerLinks___1WqW6","footerCR":"footer-module__footerCR___2h7YJ"};